import { type Ref, ref } from 'vue'

import type { Nullable } from './types'

export interface ISolidgateException extends Error {
  readonly hasErrors: boolean
  data: Ref<SolidgatePaymentError>
}

export type SolidgatePaymentError = {
  message: string
  status: number
  isApiError: boolean
  orderId: string
  originalData: Nullable<any>
}

/**
 * Represents a custom exception for handling errors from Solidgate.
 */
export class SolidgateException extends Error implements ISolidgateException {
  static readonly __brand: unique symbol = Symbol('SolidgateException')
  public data: Ref<SolidgatePaymentError>

  /**
   * Constructs a new ValidationException.
   *
   * @param {SolidgatePaymentError} data - The data containing the error details.
   */
  constructor(data: SolidgatePaymentError) {
    super('Solidgate Exception')

    this.name = 'SolidgateException'

    // Error.captureStackTrace(this, SolidgateException)

    this.message = data.message
    this.data = ref(data)
  }
  /**
   * Checks if there are any validation errors.
   *
   * @returns {boolean} - True if there are any validation errors, false otherwise.
   */
  get hasErrors(): boolean {
    return Object.values(this.data ?? {}).length > 0
  }
}
